import React, { Component } from 'react';
import SimuladoAgendamento from './SimuladoAgendamento';
import ModalAgendar from './ModalAgendar';

import Alert from 'react-s-alert';

class TabelaSimuladosAgendamento extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showModalAgendar: false,
            loadingModal: false
        };

        this.openModalAgendar = this.openModalAgendar.bind(this);
        this.closeModalAgendar = this.closeModalAgendar.bind(this);
    }

    async openModalAgendar(idEventPracticeTest, idEvent, action, testType, periodPracticeTest, periodSchoolGrade) {
        // console.log('openModalAgendar this.props.practiceTestContainer', this.props.practiceTestContainer.state.simulado)
        this.setState({ showModalAgendar: true, loadingModal: true });
        if (action !== 'editar') {
            await this.props.practiceTestContainer.setState({
                simulado: {
                    dtEndEvent: new Date(),
                    dtStartEvent: new Date(),
                }
            })

            await this.props.userContainer.getConfigurations()
        }

        await this.props.practiceTestContainer.setState({ action: action, selectedSchool: this.props.userContainer.state.selectedSchool, selectedGrade: this.props.userContainer.state.selectedGrade, selectedEventPracticeTest: idEventPracticeTest, selectedPeriodSchoolGrade: periodSchoolGrade, selectedPracticeTestType: testType, selectedPeriodPracticeTest: periodPracticeTest, selectedEvent: idEvent })

        await this.props.practiceTestContainer.getPracticeConfig();
        this.setState({ loadingModal: false });
    }

    async closeModalAgendar(updateTable) {

        if (updateTable === true && this.props.onAtualizarTabela) {
            this.props.onAtualizarTabela(true, async _ => {
                const agendamento = await this.props.practiceTestContainer.saveTurmasAgendadas()
                if (agendamento) Alert.info(agendamento)

                this.setState({ showModalAgendar: false });
            })
        } else {
            this.setState({ showModalAgendar: false });
        }
    }

    getTable() {
        return this.props.practiceTestContainer.state.periodos.map((period, index) => {
            // console.log(period)
            return (
                <React.Fragment key={index}>
                    <h3 className="edb-text-bolder edb-margin-top">{period.txPeriodPracticeTest} <span className="edb-medium edb-text-normal">de {period.dtStartPeriod} a {period.dtEndPeriod}</span></h3>

                    {period.p.map(fir => {
                        return (
                            fir.t.map((simulation, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <strong>{simulation.txPracticeTestType}</strong>
                                        <SimuladoAgendamento
                                            isProfessor={this.props.isProfessor}
                                            className="edb-margin-top edb-margin-large-bottom"
                                            classAvailable={simulation.ClassAvailable}
                                            periodoSimulado={fir.idPeriodPracticeTest}
                                            periodoSerie={period.idPeriodSchoolGrade}
                                            tipoSimulado={simulation.idPracticeTestType}
                                            dados={this.props.practiceTestContainer.state.agendamentos.filter(ag => parseInt(ag.idPracticeTestType) === simulation.idPracticeTestType && parseInt(ag.idPeriodPracticeTest) === fir.idPeriodPracticeTest)}
                                            onClickAgendar={this.openModalAgendar}
                                            practiceTestContainer={this.props.practiceTestContainer}
                                            onUpdated={this.props.onAtualizarTabela}
                                            onDelete={this.props.practiceTestContainer.excluirAgendaSimulado}
                                            getStudents={this.props.practiceTestContainer.getStudentsClass}
                                            loadingTabela={this.props.practiceTestContainer.state.loadingTabela}
                                            existExam={simulation.ExistsExam} />
                                    </React.Fragment>
                                )
                            })
                        )
                    })}
                </React.Fragment>
            )
        })
    }

    render() {
        return (
            <>

                {this.state.showModalAgendar &&
                    <ModalAgendar
                        isOpen={this.state.showModalAgendar}
                        loading={this.state.loadingModal}
                        onCloseModal={this.closeModalAgendar}
                        practiceTestContainer={this.props.practiceTestContainer}
                        userContainer={this.props.userContainer}
                    />}

                {this.getTable()}

            </>
        )
    }
}

export default TabelaSimuladosAgendamento;